import { getChargebackStats } from "@/services/disputes.service";
import { useQuery } from "@tanstack/react-query";

// disputeResolutionStatus[] is a per-outcome breakdown, e.g.
// [{ status: "UNDER_REVIEW", count: 3 }, ...] — its 4 values map directly to
// the tiles below (see CHARGEBACK_STATUS in pages/disputes/data.js).
const countFor = (breakdown, status) =>
  breakdown?.find((entry) => entry.status === status)?.count ?? 0;

export const useChargebackStats = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["chargebackStats"],
    queryFn: getChargebackStats,
    select: (res) => res?.data,
  });

  return {
    stats: {
      totalCount: data?.totalCount ?? 0,
      awaitingResponseCount: countFor(data?.disputeResolutionStatus, "RESPONSE_NEEDED"),
      merchantRespondedCount: countFor(data?.disputeResolutionStatus, "UNDER_REVIEW"),
      resolvedCount:
        countFor(data?.disputeResolutionStatus, "MERCHANT_WON") +
        countFor(data?.disputeResolutionStatus, "CUSTOMER_WON"),
    },
    isLoading,
    isError,
  };
};
